module.exports = "/_next/static/images/logo-dark-ru-c7c246e4de39176532c6e4d92ee9a4bf.png";